export const searchByDateInit = {
  isSearch: null,
  start: '',
  end: '',
};
